(function () {

    SUGApp.service('signupPageService', ['SUGUtilities','sugCacheFactory','$filter','$modal','$q', function(SUGUtilities,sugCacheFactory,$filter,$modal,$q){

        var service = {
            urlparts: [],
            urlkey : '',
            tabgroupurlkey : '',
            tabindex: 0,
            memberinfo : {},
            signupinfo : {},
            themeinfo : {},
            tabgroup : {},
            calendardates: {
                arrSignUpDates: [],
                displayMonth: {},
            },
            currentMonth: undefined,
            paginationMetadata: undefined,
            customThemeId: undefined,
        };

        var defaultTtl = 60000; // 1 minute

        /**
         * Toggles the default TTL for the cache to 1 ms, effectively disabling it, for a period of 1 minute.
         * This is used to force a refresh of the cache when the user signs up for a slot.
         */
        service.toggleDefaultTtl = function() {
            // toggle the default TTL to 1 ms for a period of 1 minute
            defaultTtl = 1;
            setTimeout(function() {
                defaultTtl = 60000;
            }, 60000);
        };

        // cache object url spliced into an array
        service.setUrlParts = function( info ){
            //URL array may start with // causing an empty string, so handle that here
            service.urlparts = info.filter(function(el){ return el === 0 || el; });
        };
        service.getUrlParts = function(){
            return service.urlparts;
        };

        // cache object
        service.setUrlKey = function( info ){
            service.urlkey = info;
        };
        service.getUrlKey = function(){
            return service.urlkey;
        };

        // cache custom theme id
        service.setCustomThemeId = function( themeId ){
            service.customThemeId = themeId;
        };
        service.getCustomThemeId = function(){
            return service.customThemeId;
        };

        // cache object for embedded portal Id
        service.setPortalId = function( info ){
            sugCacheFactory.set('embed_portalId', info);
        };
        service.getPortalId = function(){
            return sugCacheFactory.get('embed_portalId', 0);
        };

        // cache object
        service.setTabGroup = function( info ){
            service.tabgroup = info;
        };

        service.getTabGroup = function(){
            return service.tabgroup;
        };

        // cache object
        service.setTabGroupUrlKey = function( info ){
            service.tabgroupurlkey = info;
        };

        service.getTabGroupUrlKey = function(){
            return service.tabgroupurlkey;
        };

        // cache object
        service.setTabIndex = function( info ){
            service.tabindex = info;
        };

        service.getTabIndex = function(){
            return service.tabindex;
        };

        // cache object
        service.setMemberInfo = function( info ){
            service.memberinfo = info;
        };

        service.getMemberInfo = function(){
            return service.memberinfo;
        };

        // cache object
        service.setSignUpInfo = function( info ){
            service.signupinfo = info;
        };

        service.getSignUpInfo = function(){
            // we can potentially override and get the data from backend
            return service.signupinfo;
        };

        service.setThemeInfo = function( info ){
            service.themeinfo = info;
        };

        service.getSignUpParticipantsBySlotItem = function ( data ) {
            return SUGUtilities.APISyncCall('post', '', data, 's.getSignUpParticipantsBySlotItem', 30000);
        };

        service.getThemeInfo = function(){
            // we can potentially override and get the data from backend
            return service.themeinfo;
        };

        service.setThemeClassInfo = function( info ){
            service.themeclassinfo = info;
        };

        service.getThemeClassInfo = function(){
            // we can potentially override and get the data from backend
            return service.themeclassinfo;
        };

        // cache object
        service.setAttrs = function( info ){
            service.attrs = info;
        };

        service.getAttrs = function(){
            return service.attrs;
        };

        service.setCalendarDates = function( data ){
            service.calendardates = data;
        };
        service.getCalendarDates = function(){
            return service.calendardates;
        };
        service.setSignUpDates = function( data ){
            service.calendardates.arrSignUpDates = data;
        };
        service.getSignUpDates = function(){
            return service.calendardates.arrSignUpDates;
        };
        service.setDisplayMonth = function( data ){
            service.calendardates.displayMonth = data;
        };

        service.getDisplayMonth = function(){
            return service.calendardates.displayMonth;
        };
        
        /** Sets the curent month into the service's state so we can persist it across pages (ex. "10-2020")
         * 
         * @param {string} data  
         */
        service.setCurrentMonth = function( data ){
            service.currentMonth = data;            
        };
        /** gets the current month string (ex. "10-2020") from the service
         * 
         * @returns string
         */
        service.getCurrentMonth = function(){
            return service.currentMonth;
        };

        /** Sets the curent month into the service's state so we can persist it across pages (ex. "10-2020")
         * 
         * @param {string} data  
         */
        service.setPaginationMetadata = function( data ){
            data.calendarview.lastCalendarMonth = new Date(data.calendarview.lastmonthwithslots);
            data.calendarview.firstCalendarMonth = new Date(data.calendarview.firstmonthwithslots);  
            service.paginationMetadata = data;       
        };
        /** gets the last stored pagination metadata from the service cache
         * 
         * @returns string
         */
        service.getPaginationMetadata = function(){
            return service.paginationMetadata;
        };

        // cache object Factory
        service.setEmbedPortalInfo = function( info ){
            sugCacheFactory.set('embed_portalBasics', info);
        };
        service.getEmbedPortalInfo = function(){
            return sugCacheFactory.get('embed_portalBasics',{});
        };

        //Convert params object into URLParts Array for use in the Router
        service.convertParamsToUrlParts = function( params ){
            if(typeof params == 'object'){
                var parts = [];
                Object.keys(params).map(function(key) {
                    parts.push(key);
                    parts.push(params[key]);
                });
              service.setUrlParts( parts );
            }
        };

        service.resultErrorHandler = function( response ){
    		var Message = "";
    		var result = SUGUtilities.lowerCaseKeys(response);
    		if( angular.isDefined(result.message) ){
    			if( angular.isArray(result.message) ){
                    angular.forEach( result.message, function(obj,key){
                        Message += obj + " ";
                    });
    			} else {
    				Message = result.message;
    			}
    		} else {
    			if( SUGUtilities.isDefinedNotNullNotEmpty(result.statustext) ){
    				Message = result.statustext;
    			} else if( typeof result.status !== undefined && result.status === 0 ){
    				Message = 'Request timeout exceeded. Make sure you are logged in and have an active session.';
    			}
    			else {
    				Message = 'An unknown error occurred while processing your request';
    			}
    		}

    		return Message;
        };

        /**
         * Get an object reflecting slot availability like {qtyLabel: "1 slot available", btnState: "default"}
         * Include a responsive version that optionally hides parts of longer labels for smaller screens
         * @intLimit - the quantity limit for the slot
         * @intTaken - the quantity taken for the slot item
         * @blnAddLocked {Boolean} - slotiem is locked or not
         * @blnSignupLocked {Boolean} - sign up is locked or not
         * @hideNumberWanted {number}
         * @waitlist {number} - instead of full shows a waitlist
         * @memberParticipantData {object array} - logged in member specific participant data to get other details from
         */
        service.getAvailability = function (intLimit, intTaken, blnAddLocked, blnSignupLocked, hideNumberWanted, hasWaitlist, memberParticipantData) {
            // return value
            const stcAvailable = {
                qtyLabel: '',
                qtyLabelResponsive: '',
                btnState: 'default',
                waitlistPosition: 0,
            };

            const strTaken = $filter('number')(intTaken);
            const strLimit = $filter('number')(intLimit);
            
            let memberAlreadyWaitlisted = isParticipantAlreadyOnWaitlist(memberParticipantData);
            let memberWaitlistPosition = 0;
            let memberAlreadySignedUpStandard = isParticipantAlreadySignedUpStandard(memberParticipantData);
            
            if (memberAlreadyWaitlisted)
                memberWaitlistPosition = getParticipantWaitlistPosition(memberParticipantData);

            if (hideNumberWanted) {
              if (intTaken > 0 && intTaken !== intLimit) {
                const label = intTaken === 1 ? '1 slot filled' : `${strTaken} slots filled`;
                stcAvailable.qtyLabelResponsive = stcAvailable.qtyLabel = label;
              } else if (intLimit === intTaken) {
                if (hasWaitlist) {
                    if (memberAlreadySignedUpStandard) {
                        stcAvailable.btnState = 'waitlist_disabled'; // shows Join Waitlist but disabled since they already signed up
                    }
                    else {
                        stcAvailable.btnState = memberAlreadyWaitlisted ? 'waitlisted' : 'waitlist';
                        stcAvailable.waitlistPosition = $filter('number')(memberWaitlistPosition);
                    }
                }
                else {
                    stcAvailable.btnState = 'full';
                }
              }
            } else if (intTaken === 0) {
                switch(intLimit) {
                    case 1:
                        stcAvailable.qtyLabel = '1 slot available';
                        break;
                    case 999999:
                        break;  // no label
                    default:
                        stcAvailable.qtyLabel = `${strLimit} slots available`;
                        break;
                }

                stcAvailable.qtyLabelResponsive = stcAvailable.qtyLabel;
            } else if (intLimit === 999999) {
                stcAvailable.qtyLabel = intTaken === 1 ? '1 slot filled (more available)' : `${strTaken} slots filled (more available)`;
                stcAvailable.qtyLabelResponsive = stcAvailable.qtyLabel.replace('(more available)', '<span class="visible-lg-inline-block">(more available)</span>');
            } else if (intLimit === intTaken) {

                if (hasWaitlist) {
                    if (memberAlreadySignedUpStandard) {
                        stcAvailable.btnState = 'waitlist_disabled'; // shows Join Waitlist but disabled since they already signed up
                    }
                    else {
                        stcAvailable.btnState = memberAlreadyWaitlisted ? 'waitlisted' : 'waitlist';
                        stcAvailable.waitlistPosition = $filter('number')(memberWaitlistPosition);
                    }
                }
                else {
                    stcAvailable.btnState = 'full';
                }

                stcAvailable.qtyLabel = intTaken === 1 ? 'All slots filled' : `All ${strTaken} slots filled`;
                stcAvailable.qtyLabelResponsive = stcAvailable.qtyLabel;
            } else {
                stcAvailable.qtyLabel = `${strTaken} of ${strLimit} slots filled`;
                stcAvailable.qtyLabelResponsive = stcAvailable.qtyLabel;
            }

            // if the sign up is locked and not full (full takes precedence), set the button to the locked state
            if (!memberAlreadyWaitlisted && (blnSignupLocked || blnAddLocked) && stcAvailable.btnState !== 'full') {
                stcAvailable.btnState = 'locked';
            }

            return stcAvailable;
        };


        service.deleteItemMember = function ( data ) {
            return SUGUtilities.APISyncCall('post', '', data, 's.deleteItemMember', 15000);
        };

        service.deleteItemMemberModal = function(modalInfo, itemmember){
            var deleteItemMemberModal = $modal.open({
                templateUrl: '/view/signups/incl_dspItemMemberDeleteModal.html',
                controller: 'deleteItemMemberModalController',
                resolve: {
                    //pass data into the modal
                    modalInfo: function(){ return modalInfo; },
                    itemmember: function(){ return itemmember; }
                },
            });

            return deleteItemMemberModal.result;
        };

        service.getsignup = function (data, ttl) {
            // default cache ttl, if not specified
            ttl = ttl || defaultTtl;
            return SUGUtilities.APISyncCallWithCaching('post', '', data, 's.getSignupInfo', 30000, ttl);
        };
        service.gettheme = function (data) {
            return SUGUtilities.APISyncCallWithCaching('post', '', data, 's.getSignUpThemeByUrlId');
        };

        service.getSignupTheme = function (data) {
            return SUGUtilities.APISyncCallWithCaching('post', '', data, 's.getSignUpTheme');	
        }   

        service.gettabgroup = function (data) {
            return SUGUtilities.APISyncCallWithCaching('post', '', data, 's.getTabGroupDetails');
        };

        service.getSignUpParticipantsBySlotItem = function ( data ) {
            return SUGUtilities.APISyncCall('post', '', data, 's.getSignUpParticipantsBySlotItem', 30000);
        };
        service.getStarterTemplateById = function ( data ) {
            return SUGUtilities.APISyncCall('post', '', data, 's.getStarterTemplateById', 30000);
        };

        service.createFromStarterTemplate  = function ( data ) {
            return SUGUtilities.APISyncCall('post', '', data, 's.createFromStarterTemplate', 30000);
        }

        /* For Embedded Signup Via Embedded Portal */
        service.getportalembeddata = function (data) {
            var deferred = $q.defer();

            //Try to get the embedPortalInfo from SUG cache factory
            var portalEmbedInfo = service.getEmbedPortalInfo();
            var keyCount = Object.keys(portalEmbedInfo).length;

            if( keyCount == 0 || (keyCount > 0 && portalEmbedInfo.portalid != data.portalid) ){
                SUGUtilities.APISyncCall('post', '', data, 'c.getPortalEmbedData', 15000)
                .then( function(response){
                    var r = SUGUtilities.lowerCaseKeys(response.data);
                    var portalEmbedInfo = { 'urlkey':'', 'memberid':0, 'portalid':data.portalid, 'title':'' };
                    if (SUGUtilities.ajaxResultInvalid(response.data)) {
                        //Silent error. If this fails backToPortal view uses default data above and handles it.
                        //console.log('::ERROR::\n', SUGUtilities.getAjaxResponseMessage(response));
                    } else {
                        portalEmbedInfo = r.data;
                    }
                    service.setEmbedPortalInfo( portalEmbedInfo );
                    deferred.resolve(portalEmbedInfo);
                }, function(err){
                    deferred.reject(err);
                });
            }else{
                deferred.resolve(portalEmbedInfo);
            }
            return deferred.promise;
        };

        /**
        * Sets fee message
        * @param {Object}    signupInfo sign up info object
        * @returns {String}  feeMessage - either empty string or feeMessage.
        */
        service.setFeeMessage = function(signupInfo){
            var feeMessage = '';
            var wprate = signupInfo.iswp && angular.isDefined(signupInfo.wprate) ? signupInfo.wprate : {'p':0,'t':0,'fee_payer':'payer_from_app'};
            var cur = signupInfo.currency;
            var fee_payer = ( signupInfo.iswp && angular.isDefined( signupInfo.wprate.fee_payer ) ) ? signupInfo.wprate.fee_payer : 'payer_from_app';
            // set fee message
            if( fee_payer == 'payer_from_app' && $filter('number')(wprate.p * 100) > 0){
                feeMessage = "A service fee of " + $filter('number')(signupInfo.wprate.p * 100) + "% + " + $filter('currency')(signupInfo.wprate.t) + ' ' + cur + " will be added to your purchase at checkout.";
            }

            return feeMessage;
        };


        /**
        * Sets the initial pagination values for a sign up
        * @param {Object}    signupInfo sign up info object
        * @param {Object}    frmObj form object
        * @returns nothing
        */
        service.initializePagination = function(signupInfo, frmObj){
            const paginationMinimumCount = 500; // this is where pagination process begins
            var totalSlots = signupInfo.slotmetadata.totalslots || 0;

            if (isSignUpLocked(signupInfo) || isAllSignUpDatesHidden(signupInfo)) {
                signupInfo.allSlotsHidden = true;
                return signupInfo;
            }

            // Initial slice values to display the first page.
            var sliceStart = 0;
            var sliceEnd = frmObj.numPerPage;
            // Convert the slots object to an array so we can slice it and only return the initial page of slots
            signupInfo.slotsArray = Object.entries(signupInfo.slots);

            // For date sorted slots, we need to show slots without a location (locationid === 0) before slots with locations. 
            if (signupInfo.itemsort === "D") {
                signupInfo.slotsArray.sort((slotA, slotB) => slotA[1].locationid > slotB[1].locationid)
            }
            signupInfo.currentSlots = signupInfo.slotsArray.slice(sliceStart, sliceEnd);

            signupInfo.listPagination = {
                itemsPerPage: frmObj.numPerPage,
                currentPage: 1,
                totalSlots: totalSlots,
                totalPages: Math.ceil(totalSlots * signupInfo.slotsArray.length / frmObj.numPerPage), // TODO this will need to come from the slotMetadata returned from the initial response                    
            };

            var allItemSlots = [];

            // We currently get all slots at once grouped within their parents under either a date or item property, we need to flatten those date or item properties into an array of the slots
            // DEV NOTE: Everything below this can eventually be replaced by an OFFSET and LIMIT on the backend
            signupInfo.slotsArray.forEach(function(itemSlot) {

                var itemDetail = itemSlot[1];
                // Item sorted uses a 'date' property that's an array of slots
                if (signupInfo.itemsort === "I") {
                    for (i = 0; i < itemDetail.dates.length; i++) {

                        var rebuiltSlot = [itemSlot[0],Object.assign({}, itemDetail, {dates: [itemDetail.dates[i]]})];
                        // console.log({rebuiltSlot})
                        allItemSlots.push(rebuiltSlot);
                    }
                } else {
                    // while other sign up types use an 'items' property as an array of slots
                    for (i = 0; i < itemDetail.items.length; i++) {

                        var rebuiltSlot = [itemSlot[0],Object.assign({}, itemDetail, {items: [itemDetail.items[i]]})];
                        // console.log({rebuiltSlot})
                        allItemSlots.push(rebuiltSlot);
                    }
                }
            })                

            // TODO Might only be needed for date sorted "D"
            allItemSlots.sort((a, b) => {
                return new Date(a[1].starttime) > new Date(b[1].starttime);
            });

            // Once we have all slots we update the total number of pages based on that number. TODO: This will come from slot metadata
            signupInfo.listPagination.totalSlots = allItemSlots.length;
            signupInfo.listPagination.totalPages = Math.ceil(allItemSlots.length / frmObj.numPerPage);

            signupInfo.showLocation = signupInfo.slotmetadata.displaycolumns.location === true;
            signupInfo.showTimeColumn = signupInfo.slotmetadata.displaycolumns.time === true;
            signupInfo.showPagination = signupInfo.listPagination.totalSlots > paginationMinimumCount;

            // when not showing pagination we need to show all at once
            if (!signupInfo.showPagination) {
                signupInfo.listPagination.itemsPerPage = paginationMinimumCount;
                frmObj.numPerPage = paginationMinimumCount;
            }

            // Then we go back over all of the slots and build an array of pages
            var paginatedItemSlots = [];
            var page = {};
            var currentPage = 0;
            allItemSlots.forEach(function(slot,index) {

                var itemId = slot[0];
                var itemDetails = slot[1]
                // If the mod is 0, we're on the next page so push the current page and create a new page of slots
                if (index % frmObj.numPerPage === 0 && index !== 0) {

                    paginatedItemSlots[currentPage] = page;
                    page = {};
                    currentPage++;
                }

                // Build a dictionary of each item on a given page and its slots that are also on that page to simulate the results returned by a paginated API
                if (Object.hasOwn(page, itemId)) {
                    // If we already have that itemId in the dictionary, add current slot
                    if (signupInfo.itemsort === "I") {
                        page[itemId].dates.push(itemDetails.dates[0])
                    } else {
                        page[itemId].items.push(itemDetails.items[0])
                    }
                } else {
                    // Otherwise create it by adding the first slot attached to that itemId
                    page[itemId] = itemDetails;
                }


            })
            // Add the last page to the list of pages when we're done
            paginatedItemSlots[currentPage] = page;
            signupInfo.slotsArray = paginatedItemSlots;

            if (signupInfo.showPagination) {
                // get the initial page from the built pages, and pass it down to each sign up controller
                signupInfo.currentSlots = signupInfo.slotsArray.slice(signupInfo.listPagination.currentPage - 1, signupInfo.listPagination.currentPage);
            }
            else {
                // get all pages
                signupInfo.currentSlots = signupInfo.slotsArray;
            }
        }

        /**
        * Returns the current waitlist count details for pill
        * @param {integer}    waitlist signup has waitlist
        * @param {integer}    waitlistedParticipantCount current count
        * @param {integer}    qty total quantity
        * @param {integer}    qtyTaken quantity signed up
        * @returns nothing
        */
        service.getWaitlistAvailability = function(waitlist, waitlistedParticipantCount, qty, qtyTaken){
            const hasWaitlist = Boolean(waitlist);
            const isFull = qtyTaken >= qty;
            if (hasWaitlist && isFull) {
              return `${Number(waitlistedParticipantCount) || 0} on waitlist`;
            }
        };

        /**
         * Gets the participant item member data
         * @param {Array} participantData - array of participant data for a specific slot/date combination
         * @param {Integer} memberid - memberid of the logged in user
         */
        service.getMemberParticipantData = function( participantData, memberid ){
            let memberParticipantData = null;

            if (memberid > 0 && participantData && participantData.length > 0) {
                memberParticipantData = participantData.filter(d => d.memberid === memberid);
            }

            return memberParticipantData;
        };


        // private methods

        // test if sign up is locked
        var isSignUpLocked = function(signupInfo){
            return typeof signupInfo.signuplocked !== 'undefined' && signupInfo.signuplocked ? true : false;
        };

        // test if has all dates are hidden
        var isAllSignUpDatesHidden = function(signupInfo){
            return typeof signupInfo.alldateshidden !== 'undefined' && signupInfo.alldateshidden ? true : false;
        };

        /**
         * Determins if the participant is already on the waitlist
         * @param {Array} participantData - array of participant data for a specific slot/date combination
         */
        var isParticipantAlreadyOnWaitlist = function( participantData ){
            if (!participantData || participantData.length <= 0)
                return false;

            return participantData.some(r => r.waitlistid > 0);
        };

        /**
         * Determins if the participant is already on the normal signup
         * @param {Array} participantData - array of participant data for a specific slot/date combination
         */
        var isParticipantAlreadySignedUpStandard = function( participantData ){
            if (!participantData || participantData.length <= 0)
                return false;

            return participantData.some(r => r.waitlistid == 0);  // find any where they aren't on the waitlist but at least one signup
        };

        /**
         * Gets the participant waitlist position
         * @param {Array} participantData - array of participant data for a specific slot/date combination
         */
        var getParticipantWaitlistPosition = function( participantData ){
            let waitlistPosition = 0;

            if (participantData && participantData.length >= 0) {
                const waitlistRecord = participantData.find(r => r.waitlistid > 0); // gets the first element, should only be one

                if (waitlistRecord) {
                    waitlistPosition = waitlistRecord.waitlistposition;
                }
            }

            return waitlistPosition;
        };

        return service;

    }]);



})();
